<template>
  <div class="mb-0 skeleton-line" :class="{ [`skeleton-line--${size}`]: true }">
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'sm',
    },
  },
};
</script>
<style>
  .skeleton-line {
    border-radius: 8px !important;
    background-color: #dedede;
  }
  .skeleton-line--lg {
    width: 100%;
    height: 32px;
  }
  .skeleton-line--md {
    width: 100%;
    height: 16px;
  }
  .skeleton-line--sm {
    width: 100%;
    height: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/skeletons/Line.vue